module.exports = __webpack_public_path__ + "static/media/mech-processing.7bc6a161.png";